import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";
import { Ferme } from '../../models/ferme.model';

@Injectable({ providedIn: 'root' })
export class FermeService {
    constructor(private http: HttpClient) { }

    getAll(): Observable<Ferme[]> {
        return this.http.get<Ferme[]>(environment.BASE_URL + `/api/fermes`);
    }

    getById(id: number): Observable<Ferme> {
        return this.http.get<Ferme>(environment.BASE_URL + `/api/fermes/${id}`);
    }

    add(ferme: any): Observable<Ferme> {
        return this.http.post<Ferme>(environment.BASE_URL + `/api/fermes`, ferme);
    }

    update(id: number, ferme: Partial<Ferme>): Observable<Ferme> {
        return this.http.put<Ferme>(environment.BASE_URL + `/api/fermes/${id}`, ferme);
    }
}
